export default {"src":"/_next/static/image/public/assets/icons/sync.c0478167c22aa0f906cb806f172c81a7.svg","height":24,"width":24};